import { Controller } from "@hotwired/stimulus";

// CSV アップロードフォームを AJAX 送信し、上書き確認のたびに full reload して
// 選択済みファイルが失われる問題を解消する (#557)。
export default class extends Controller {
  static targets = [
    "form",
    "submitButton",
    "overwriteRow",
    "overwrite",
    "alert",
    "errors",
  ];

  static values = { askOverwrite: Boolean };

  submit(event) {
    event.preventDefault();

    this.clearAlert();
    this.clearErrors();
    this.setLoading(true);

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content;
    const formData = new FormData(this.formTarget);

    fetch(this.formTarget.action, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: formData,
    })
      .then((response) => this.parseResponse(response))
      .then((data) => this.handleResponse(data))
      .catch(() => {
        this.showAlert("通信エラーが発生しました。もう一度お試しください。");
        this.setLoading(false);
      });
  }

  // サーバーが JSON 以外 (HTML エラーページ等) を返したり非 OK ステータスで応答した
  // 場合でも、一律「通信エラー」に丸めずに可能な限り具体的な内容を表示する (#2027)。
  // JSON が取れれば status:"error" + html(エラー行) も含めてそのまま handleResponse へ
  // 渡し、取れなければサーバーエラーとして扱う。
  async parseResponse(response) {
    const contentType = response.headers.get("Content-Type") || "";

    if (contentType.includes("application/json")) {
      // 非 OK でも本文に status/message/html があれば尊重する。
      return response.json();
    }

    // JSON でない応答 (サーバーエラーの HTML など)。詳細は伝えられないため、
    // 通信エラーではなくアップロード処理側のエラーである旨を明示する。
    return {
      status: "error",
      message: response.ok
        ? "サーバーから想定外の応答がありました。もう一度お試しください。"
        : "アップロード処理でエラーが発生しました。CSVの内容をご確認のうえ、もう一度お試しください。",
    };
  }

  handleResponse(data) {
    switch (data.status) {
      case "redirect":
        window.location.href = data.redirect_url;
        break;
      case "ask_overwrite":
        this.revealOverwrite();
        this.showAlert(data.message);
        this.setLoading(false);
        break;
      case "error":
        if (data.html) {
          this.errorsTarget.innerHTML = data.html;
        }
        if (data.message) {
          this.showAlert(data.message);
        }
        this.setLoading(false);
        break;
      default:
        this.setLoading(false);
    }
  }

  revealOverwrite() {
    this.overwriteRowTarget.classList.remove("d-none");
    if (this.hasOverwriteTarget) {
      this.overwriteTarget.checked = false;
    }
  }

  setLoading(loading) {
    if (!this.hasSubmitButtonTarget) return;

    this.submitButtonTarget.disabled = loading;
    this.submitButtonTarget.value = loading
      ? "アップロード中..."
      : "アップロードする";
  }

  showAlert(message) {
    if (!message) return;

    this.alertTarget.innerHTML = `<div class="alert alert-warning">${message}</div>`;
  }

  clearAlert() {
    this.alertTarget.innerHTML = "";
  }

  clearErrors() {
    this.errorsTarget.innerHTML = "";
  }
}
